import React from "react";
import Layout from "../components/Layout/Layout";
import "../styles/breadcrumb.css";

const Breadcrumb = () => {
    return (
        <nav className="breadcrumb-container">
            <ul className="breadcrumb">
                <li><a href="/">Home</a></li>
                <li><a href="/releases">Release</a></li>
                <li className="active">Release Notes 2.1</li>
            </ul>
        </nav>
    );
};

const ReleaseNotes = () => {
    return (
        <Layout>
            <div className="release-notes-container">
                {/* Add Breadcrumb Component */}
                <Breadcrumb />

                <header className="release-header">
                    <h1 className="marginBottom10px">Release Notes</h1>
                    <h2>Finkoda Web Application v2.1</h2>
                    <p><strong>Release Date:</strong> January 22, 2025</p>
                </header>

                <section className="features-section">
                    <h3>New Features</h3>
                    <ul className="custom-list">
                        <li>
                            <strong>Modern UI/UX Redesign</strong>
                            <p className="marginTop5px">Completely revamped user interface for better usability and modern look.</p>
                            <p>Enhanced visual consistency and improved navigation across all platforms.</p>
                        </li>
                        <li>
                            <strong>Nominee Management System</strong>
                            <p className="marginTop5px">Added the ability to manage nominees for your accounts.</p>
                            <p>Easily add, edit, or remove nominees with just a few clicks.</p>
                        </li>
                        <li>
                            <strong>Google OAuth Integration</strong>
                            <p className="marginTop5px">Simplified login process with secure Google authentication.</p>
                            <p>One-click sign-in for returning users with Google accounts.</p>
                        </li>
                    </ul>
                </section>

                <section className="improvements-section">
                    <h3>Improvements</h3>
                    <ul className="custom-list">
                        <li>
                            <strong>Enhanced Security</strong>
                            <p className="marginTop5px">Implemented additional security layers for better data protection.</p>
                            <p>Improved password policies and account recovery options.</p>
                        </li>
                        <li>
                            <strong>Performance Optimizations</strong>
                            <p className="marginTop5px">Reduced app loading times and improved overall responsiveness.</p>
                            <p>Optimized data synchronization between devices.</p>
                        </li>
                        <li>
                            <strong>Mobile Experience</strong>
                            <p className="marginTop5px">Enhanced mobile responsiveness across all screens and devices.</p>
                            <p>Improved touch targets and gesture support for better mobile navigation.</p>
                        </li>
                    </ul>
                </section>

                <section className="bug-fixes-section">
                    <h3>Bug Fixes</h3>
                    <ul className="custom-list">
                        <li>Resolved synchronization problems between web and mobile platforms</li>
                        <li>Addressed minor UI glitches and alignment issues</li>
                        <li>Fixed issues with form validations and error messages</li>
                    </ul>
                </section>

                <section className="important-notes-section">
                    <h3>Important Notes</h3>
                    <ul className="custom-list">
                        <li><strong>Update Required</strong> - Please update to the latest version to access all new features and security improvements.</li>
                        <li><strong>Feedback Welcome</strong> - Your input is valuable to us! Share your thoughts and suggestions at <a href="mailto:contact@finkoda.com">contact@finkoda.com</a>.</li>
                    </ul>
                </section>

                <footer className="release-footer">
                    <p>Thank you for choosing Finkoda as your trusted financial partner!</p>
                </footer>
            </div>
        </Layout>
    );
};

export default ReleaseNotes;
